import { useMemo } from 'react'
import { UserInfo, useUserInfo } from '../../../../ReactRouting/Hooks/useUserInfo'
import { useCheckUserHasPermissions } from '../../../../ReactRouting/Hooks/useCheckPermissions'
import { PermissionsUtil, QUEUE_MANAGEMENT_PERMISSIONS } from '../../Utils/PermissionsUtil'
import { TelSysTypes } from '../../../TelSysConfiguration/Constants/Constants'

export const useUserHasManageQueuePermission = (): Definable<boolean> => {
    const [userInfo]: UserInfo = useUserInfo()
    const hasQueueManagementPermissions: Definable<boolean> = useCheckUserHasPermissions(QUEUE_MANAGEMENT_PERMISSIONS)
    const doesUserHaveMSTeamsTelsys: Definable<boolean> = useMemo(
        (): Definable<boolean> => PermissionsUtil.hasTelSysType(userInfo, TelSysTypes.MS_TEAMS),
        [userInfo]
    )

    return hasQueueManagementPermissions && (doesUserHaveMSTeamsTelsys || PermissionsUtil.isCMEWideUser(userInfo))
}
